import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SidebarContent from '../components/Sidebar/SidebarContent';

const DashboardLayout: React.FC = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <div
      className="min-h-screen w-full bg-slate-100 flex flex-col lg:flex-row"
      dir="rtl"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      {/* ۱. سایدبار دسکتاپ (فقط مانیتورهای بزرگ) */}
      <aside className="hidden lg:block fixed top-0 right-0 h-screen w-64 bg-[#161b2e] z-30 shadow-xl overflow-y-auto">
        <SidebarContent />
      </aside>

      {/* ۲. هدر بالایی مخصوص موبایل و تبلت - در دسکتاپ (lg) کاملاً مخفی می‌شود */}
      <header
        className="flex lg:hidden w-full bg-[#161b2e] px-4 items-center justify-between sticky top-0 shadow-md shrink-0"
        style={{
          height: '64px',
          backgroundColor: '#161b2e',
          zIndex: 9999,
        }}
      >
        {/* دکمه باز کردن منو */}
        <button
          onClick={() => setIsMobileOpen(true)}
          className="hover:bg-white/10 rounded-xl transition flex items-center justify-center border border-white/10"
          style={{
            width: '44px',
            height: '44px',
            backgroundColor: 'rgba(255,255,255,0.08)',
            color: '#e2e8f0',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          aria-label="منو"
        >
          <svg
            style={{ width: '28px', height: '28px' }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        <span
          style={{
            color: '#e2e8f0',
            fontWeight: '800',
            fontSize: '15px',
            letterSpacing: '0.5px',
          }}
        >
          داشبورد تیداکو
        </span>
      </header>

      {/* ۳. منوی کشویی موبایل (Drawer) */}
      {/* لایه تیره کننده پشت منو */}
      <div
        className={`lg:hidden fixed inset-0 transition-opacity duration-300 ${
          isMobileOpen
            ? 'opacity-100 pointer-events-auto'
            : 'opacity-0 pointer-events-none'
        }`}
        style={{
          zIndex: 99999,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: isMobileOpen ? 'block' : 'none',
        }}
        onClick={() => setIsMobileOpen(false)}
      />

      {/* بدنه سایدبار کشویی موبایل */}
      <aside
        className={
          'lg:hidden fixed top-0 right-0 h-screen w-72 max-w-[80vw] bg-[#161b2e] transition-transform duration-300 ease-in-out shadow-2xl flex flex-col'
        }
        style={{
          zIndex: 100000,
          position: 'fixed',
          transform: isMobileOpen ? 'translateX(0)' : 'translateX(100%)',
        }}
      >
        <div className="p-4 flex justify-between items-center border-b border-white/5 bg-[#121626]">
          <span className="text-gray-400 font-bold text-xs">منوی دسترسی</span>
          <button
            onClick={() => setIsMobileOpen(false)}
            className="text-gray-400 hover:text-white p-2"
          >
            <svg
              style={{ width: '20px', height: '20px' }}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto">
          <SidebarContent onItemClick={() => setIsMobileOpen(false)} />
        </div>
      </aside>

      {/* ۴. بخش محتوای داخلی */}
      <main className="flex-1 w-full lg:pr-64 min-h-screen p-4 sm:p-6 overflow-x-hidden bg-[#0f1322]">
        <div className="max-w-6xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
